import React from "react";
import get from "lodash/get";
import { CloseIcon } from "~/assets/svg";
import VideoJSPlayer from "~/components/VideoPlayer";
import { updateXY, hoverOnVolumePanel, displayCC } from "./helper";
import { muteLivePlayer, unmuteLivePlayer } from "~/components/ExpandedDetails/helper";

const customVideoJSControls = {
	volumePanel: { inline: false },
	children: [
		"playToggle",
		"progressControl",
		"currentTimeDisplay",
		"timeDivider",
		"durationDisplay",
		"volumePanel",
		"fullscreenToggle"
	]
}

class StandAlonePlayers extends React.Component {
	state = {
		isDragging: false,

		originalX: 0,
		originalY: 0,

		translateX: 0,
		translateY: 0,

		lastTranslateX: 0,
		lastTranslateY: 0,

		player: null
	};

	componentWillUnmount() {
		window.removeEventListener("mousemove", this.handleMouseMove);
		window.removeEventListener("mouseup", this.handleMouseUp);
	}

	handleMouseDown = (env) => {
		const { isPip } = this.props;
		if(isPip && this.state.player && !this.state.player.isFullscreen() &&!hoverOnVolumePanel()){
			env.preventDefault();
			env.stopPropagation();
			const { clientX, clientY } = env;
			window.addEventListener("mousemove", this.handleMouseMove);
			window.addEventListener("mouseup", this.handleMouseUp);
	
			this.setState({
				originalX: clientX,
				originalY: clientY,
				isDragging: true
			});
		}
	};

	handleMouseMove = (env) => {
		env.preventDefault();
		env.stopPropagation();
		const { clientX, clientY } = env;
		const { isDragging } = this.state;

		if (!isDragging) {
			return;
		} else {
			this.setState(prevState => ({
				translateX: clientX - prevState.originalX + prevState.lastTranslateX,
				translateY: clientY - prevState.originalY + prevState.lastTranslateY
			}));
		}

	};

	handleMouseUp = (env) => {
		env.preventDefault();
		env.stopPropagation();
		window.removeEventListener("mousemove", this.handleMouseMove);
		window.removeEventListener("mouseup", this.handleMouseUp);
		const { x, y } = updateXY(this.state);

		this.setState({
			originalX: 0,
			originalY: 0,
			lastTranslateX: x,
			lastTranslateY: y,
			isDragging: false
		});
	};

	setupDragStyle = () => {
		if (this.props.isPip) {
			const { x, y } = updateXY(this.state);

			return {
				transform: `translate(${x}px, ${y}px)`
			};
		}
		return {};
	};

	getVideoRef = (player) => {
        this.setState({player: player},()=>{
            window.newsLivePlayer = player;
            displayCC(player, true);
            if(this.props.isPip === true){
                muteLivePlayer();
            }else {
				!get(window, 'settings.features.mute_sound') && unmuteLivePlayer();
			}
			
			//Mute live player when user sustain tab in background - RTA-851
			//Can be removed when videojs team fix this issue
            window.document.addEventListener("visibilitychange", function(){
				if(window.newsLivePlayer){
					if (document.hidden){
						window.newsLivePlayerMuteState = window.newsLivePlayer.muted();
						window.newsLivePlayer.muted(true);
					} else {
						if(!window.newsLivePlayerMuteState){
							!get(window, 'settings.features.mute_sound') && window.newsLivePlayer.muted(false);
						}
					}
				}
			});

			// mute mini player in firstplay
			player.on('firstplay', (e) => {
				if(this.props.mutePlayerAtBeginning || !this.props.topPlayerIsVisible || window._shouldMuteLivePlayer){
					muteLivePlayer();
				}
			})
		});
    }

	componentDidUpdate(prevProps, prevState){
		const { player } = this.state;
		const { isPip, currentVideo, topPlayerIsVisible } = this.props;

		if(player){
			if(prevProps.isPip !== isPip){
				if(isPip === true || (window.newsTrailerPlayer && window.newsTrailerPlayer.player_)){
					muteLivePlayer();
				}else if(topPlayerIsVisible){
					!get(window, 'settings.features.mute_sound') && unmuteLivePlayer();
				}
			} 
		}
		if(player !== prevState.player){
			//Hide controlbar when video starts
			player.userActive(false);
		}

		const newId = currentVideo && currentVideo.gist && currentVideo.gist.id;
		const oldId = prevProps.currentVideo && prevProps.currentVideo.gist && prevProps.currentVideo.gist.id;

		if(newId && oldId && newId !== oldId){
			displayCC(player, true);
		}
	}

	render() {
		const getVideo = path => get(this.props.currentVideo, path);
		const {
			isPip,
			disablePip,
			currentVideo,
			isPlaylistItem,
			nextVideoDataAction,
			hideAds,
			shouldPlayAds,
			videoEndedHandler,
			isPromo
		} = this.props;
		const isLive = getVideo("gist.isLiveStream");
		const enablePWA = window.settings.features.enablePWA;

		return (
			<div
				className={
					"StandaloneVideoPlayer02 site-border-color" +
					(isPip ? " StandaloneVideoPlayer02-pip" : "")
				}
			>
				<div
					className={`StandaloneVideoPlayer02-player${enablePWA ? ' PWAMoveUp' : ''}`}
					onMouseDown={(env) => this.handleMouseDown(env)}
					draggable={isPip ? `true` : "false"}
					style={this.setupDragStyle()}
				>
					<button
						className="StandaloneVideoPlayer02-close-button"
						onClick={disablePip}
					>
						<CloseIcon />
					</button>
					<VideoJSPlayer
						video={currentVideo}
						customSkin={'./newsSkin'}
						customControls={customVideoJSControls}
						isPlaylistItem={isPlaylistItem}
						nextVideoDataAction={nextVideoDataAction}
						videoId={getVideo("gist.id")}
						videoTag={get(window.settings, "advertising.videoTag")}
						isFree={getVideo("gist.free")}
						// hlsSrc={getVideo("streamingInfo.videoAssets.hls")}
						permalink={getVideo("gist.permalink")}
						autoplay={true}
						fileType={isLive ? 'hls' : 'mp4'}
						hideAds={hideAds}
						pricingOptions={getVideo("pricing")}
						isLive={isLive}
						ref={el=>this.player=el}
						getVideoRef={this.getVideoRef.bind(this)}
						disableNextEpisodeTimer={true}
						videoEndedHandler={videoEndedHandler}
						enableAdsForNews={true}
						shouldPlayAds={shouldPlayAds}
						isPromo={isPromo}
					/>
				</div>
			</div>
		);
	}
}

export default StandAlonePlayers;